import {RetentionType} from 'common/report/util/retention/types';

export const REPORT_TYPES = {
  ADDICTION: `addiction`,
  RETENTION: `retention`,
};

export const AGGREGATED_ROW_NAME = (reportType: RetentionType) =>
  `Average ${reportType === `addiction` ? `Frequency` : `Retention`}`;
